import React, { useState, useContext, useEffect } from "react";
import { IoIosStarOutline, IoIosStar } from "react-icons/io";
import { AiOutlineCaretDown, AiFillCaretUp } from "react-icons/ai";
import ParameterContext from "../context/parameter/parameterContext";
import AuthContext from "../context/auth/authContext";
import CryptoContext from "../context/crypto/cryptoContext";
import NumberFormat from "react-number-format";
import getSymbolFromCurrency from "currency-symbol-map";
import Pagination from "../components/Pagination";
import Badge from "../components/Badge";
import { formatNumber } from "../helpers/format";
import HomeChart from "../components/HomeChart";
import { Link } from "react-router-dom";
import Price from "../components/Price";
import HomeCarousel from "../components/Home/Carousel";
import VTradingContext from "../context/vTrading/VTradingContext";
import Modal from "../components/Modal";
import TradathonContext from "../context/tradathon/TradathonContext";
import TradathonModal from "../components/TradathonModal";
import DummyCryptos from "./DummyCryptos";
import { AiOutlineUp } from "react-icons/ai";

import ReactTooltip from "react-tooltip";
import ScrollToTop from "react-scroll-to-top";
const Home = ({ history, location }) => {
  const {
    isAuthenticated,
    addFavouriteCoin,
    favouriteCoins,
    userData,
    getUser,
    favouriteLoading,
  } = useContext(AuthContext);
  const {
    cryptoData,
    convt,
    sortGlobalTickerByPrice,
    order,
    sortGlobalTickerBy24h,
    sortGlobalTickerByRank,
    sortGlobalTickerBy7d,
    sortGlobalTickerByName,
    sortGlobalTickerByMarketCap,
    sortGlobalTickerByVolumeIn24h,
    filter,
    filteredCryptoData,
    loading,
    sparklineData,

    exchangeRate,
    livePriceData,
    sortNormally,
  } = useContext(CryptoContext);
  const {
    setColumnName,
    columnName,
    toggleVtradingModal,
    vtradingModal,

    page,
    toggleModal,
  } = useContext(ParameterContext);
  const {
    toggleTradathonModal,
    tradathonModal,
    tradathon_setActivePrice,
    tradathon_setActiveCrypto,
    activeRoom,
    tradathon_setSellType,
  } = useContext(TradathonContext);
  const { setActiveCrypto, setActivePrice, PCSTAmount } =
    useContext(VTradingContext);
  const [favourite, setFavourite] = useState(null);
  // const [openBuy, setOpenBuy] = useState(false);

  // const currencySymbol = getSymbolFromCurrency(localCurrency!==convt?localCurrency:convt);

  const [data, setData] = useState(null);

  // const currencySymbol = getSymbolFromCurrency(localCurrency!==convt?localCurrency:convt);
  const currencySymbol = getSymbolFromCurrency(convt);

  const handleClick = (id) => {
    history.push(`/cryptos/${id}`);
  };

  const handleFavouriteClick = (id) => {
    setFavourite(id);
    if (isAuthenticated) {
      addFavouriteCoin(id);
    } else {
      toggleModal();
    }
  };
  useEffect(() => {
    sortNormally();
    setColumnName(null);

    if (location.pathname === "/vtrading/screen") {
      if (PCSTAmount === null) {
        history.push("/vtrading");
      }
    }
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (filter) {
      setData(filteredCryptoData);
    } else {
      if (cryptoData && cryptoData.length > 0) {
        setData(cryptoData.slice(20 * page, 20 * page + 20));
      }
    }
  }, [filter, page, cryptoData, filteredCryptoData, columnName, order]);
  useEffect(() => {
    if (!favouriteCoins && userData) {
      getUser(2);
    }
    //eslint-disable-next-line
  }, [favouriteCoins]);
  return (
    <>
      <div className="Home">
        <div className="Home__container">
          <ScrollToTop smooth component={<AiOutlineUp />} />
          {location.pathname === "/" && (
            <HomeCarousel style={{ marginBottom: "20px" }} />
          )}

          {location.pathname !== "/tradathon/screen" && vtradingModal && (
            <Modal />
          )}
          {location.pathname === "/tradathon/screen" && tradathonModal && (
            <TradathonModal />
          )}
          {location.pathname === "/" && (
            <div className="Home__TableHeader">
              <div className="Home__TableHeader-buttons__group">
                <button
                  className="Home__watchlist-button"
                  onClick={() => history.push("/favourite")}
                >
                  <IoIosStar
                    size={20}
                    style={{ color: "#FFB528", marginRight: "5px" }}
                  />
                  <span> Watchlist</span>
                </button>
              </div>
            </div>
          )}
          {location.pathname !== "/" && (
            <div className="Home__TableHeader">
              <h2 style={{ visibility: "hidden" }}>Selected (12)</h2>
              <div
                className="Home__TableHeader-buttons__group"
                style={{ gap: "10px" }}
              >
                {/* <div className="Home__exchange-rate-button__wrapper">
                  <button
                    className="Home__exchange-rate-button"
                    onClick={() => setClose(!close)}
                  >
                    {localCurrency}
                  </button>

                  {close ? (
                    <></>
                  ) : (
                    <div className="Home__setCurrency">
                      {currencies.map((c) => (
                        <div
                          className="Header__setCurrency__items"
                          onClick={() => {
                            setLocalCurrency(c.id);
                            setClose(!close);
                          }}
                        >
                          <span>{c.id}</span>
                          <CurrencyFlag currency={c.id} size="sm" />
                          <span>{c.name}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div> */}

                <button
                  className="TradathonRoom__join__button"
                  style={{
                    background: "rgba(69, 170, 67, 1)",
                    borderRadius: "5px",
                  }}
                  onClick={() =>
                    history.push(
                      location.pathname === "/tradathon/screen"
                        ? `/tradathon/addcoins?rmid=${activeRoom._id}&rid=${activeRoom.rid}`
                        : "/vtrading"
                    )
                  }
                >
                  &nbsp;Done&nbsp;
                </button>
              </div>
            </div>
          )}
          {/*Table*/}
          <div
            className="Home__tableContainer"
            style={{
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
            }}
          >
            {loading ||
            !cryptoData ||
            !cryptoData.length > 0 ||
            !sparklineData ? (
              <DummyCryptos />
            ) : (
              <table className="Home__MainTable">
                <thead>
                  <tr>
                    <th></th>
                    <th style={{ textAlign: "left" }}>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "rank" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "rank" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerByRank();
                              setColumnName("rank");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            #
                          </div>
                        </div>
                      </div>
                    </th>
                    <th style={{ textAlign: "left" }}>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "name" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "name" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerByName();
                              setColumnName("name");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Name
                          </div>
                        </div>
                      </div>
                    </th>
                    <th style={{ textAlign: "right" }}>
                      <div
                        className="Home__MainTable-th"
                        style={{ justifyContent: "flex-end" }}
                      >
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "price" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "price" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerByPrice();
                              setColumnName("price");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Price
                          </div>
                        </div>
                      </div>
                    </th>
                    <th style={{ textAlign: "right" }}>
                      <div
                        className="Home__MainTable-th"
                        style={{ justifyContent: "flex-end" }}
                      >
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "24h%" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "24h%" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerBy24h();
                              setColumnName("24h%");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            24h %
                          </div>
                        </div>
                      </div>
                    </th>
                    <th style={{ textAlign: "right" }}>
                      <div
                        className="Home__MainTable-th"
                        style={{ justifyContent: "flex-end" }}
                      >
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName && columnName === "7d%" && order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "7d%" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerBy7d();
                              setColumnName("7d%");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            7d%
                          </div>
                        </div>
                      </div>
                    </th>
                    <th style={{ textAlign: "right" }}>
                      <div
                        className="Home__MainTable-th"
                        style={{ justifyContent: "flex-end" }}
                      >
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "marketcap" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "marketcap" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerByMarketCap();
                              setColumnName("marketcap");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Market Cap
                          </div>
                        </div>
                      </div>
                    </th>
                    <th style={{ textAlign: "right" }}>
                      <div
                        className="Home__MainTable-th"
                        style={{
                          justifyContent: "flex-end",
                        }}
                      >
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "volumeIn24h" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "volumeIn24h" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerByVolumeIn24h();
                              setColumnName("volumeIn24h");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Volume(24h)
                          </div>
                        </div>
                      </div>
                    </th>
                    <th style={{ textAlign: "right", paddingRight: "20px" }}>
                      <div
                        className="Home__MainTable-th"
                        style={{ justifyContent: "flex-end" }}
                      >
                        <div>
                          <p>Last 7 days</p>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data && data.length > 0 ? (
                    data.map((c, index) => (
                    
                        <tr
                          key={c.rank ? c.rank : c.id}
                          className="Home__MainTable__link"
                        >
                          <td style={{ textAlign: "left" }}>
                            <div className="Home__MainTable-td">
                              {favouriteLoading && c.id === favourite ? (
                                <div
                                  className="loader1"
                                  style={{
                                    height: "15px",
                                    width: "15px",
                                    display: "inline-block",
                                    border: "3px solid #f3f3f3",
                                    borderTop: "3px solid #8d0792",
                                    marginLeft: "5px",
                                  }}
                                ></div>
                              ) : (
                                <div>
                                  <ReactTooltip
                                    place="bottom"
                                    effect="float"
                                    data-for="win"
                                  />
                                  {favouriteCoins &&
                                  favouriteCoins.length > 0 &&
                                  favouriteCoins.includes(c.id) ? (
                                    <IoIosStar
                                      size={22}
                                      style={{
                                        marginRight: "4px",
                                        paddingTop: "5px",
                                        cursor: "pointer",
                                        color: "rgba(141, 7, 146, 1)",
                                        outline: "none",
                                      }}
                                      data-tip="Remove from Watchlist"
                                      id="win"
                                      onClick={() => handleFavouriteClick(c.id)}
                                    />
                                  ) : (
                                    <IoIosStarOutline
                                      data-tip="Add to Watchlist"
                                      size={22}
                                      style={{
                                        marginRight: "4px",
                                        paddingTop: "5px",
                                        cursor: "pointer",
                                        outline: "none",
                                      }}
                                      onClick={() => handleFavouriteClick(c.id)}
                                    />
                                  )}
                                </div>
                              )}
                            </div>
                          </td>

                          {loading ? (
                            <td style={{ textAlign: "left" }}>
                              <div className="Home__MainTable-td">
                                <div className="skeleton text" />
                              </div>
                            </td>
                          ) : (
                            <Price
                              id={c.id}
                              item={c.rank ? c.rank : ""}
                              property="rank"
                              style1={{ textAlign: "left" }}
                            />
                          )}

                          {loading ? (
                            <td style={{ textAlign: "left" }}>
                              <div
                                className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                                style={{ justifyContent: "space-between" }}
                              >
                                <div
                                  className="skeleton avatar"
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    marginRight: "5px",
                                  }}
                                />
                                <div
                                  className="skeleton text"
                                  style={{ width: "50px" }}
                                />
                                <div
                                  className="skeleton text"
                                  style={{ width: "120px" }}
                                />
                                <div
                                  className="skeleton text"
                                  style={{ width: "60px" }}
                                />
                                <div className="shimmer-wrapper">
                                  <div className="shimmer"></div>
                                </div>
                              </div>
                            </td>
                          ) : (
                            <td style={{ textAlign: "left" }}>
                              <div className="Home__MainTable-td">
                                <img
                                  src={c.logo_url}
                                  alt="bitcoin"
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    marginRight: "5px",
                                  }}
                                />
                                <p
                                  style={{
                                    marginRight: "5px",
                                    whiteSpace: "normal",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleClick(c.id)}
                                >
                                  {c.name}
                                </p>
                                <p
                                  style={{
                                    color: "#A8A8A8",
                                    marginRight: "5px",
                                  }}
                                >
                                  {c.id}
                                </p>
                                {/* <div
                                    onClick={() => {
                                      getCompareCryptoCoinData1(c.id);
                                      setTimeout(
                                        () => history.push("/compare"),
                                        1000
                                      );
                                    }}
                                  >
                                    <Badge />
                                  </div> */}
                                {location.pathname === "/" ? (
                                  <></>
                                ) : location.pathname ===
                                  "/tradathon/screen" ? (
                                  <div
                                    onClick={() => {
                                      tradathon_setActiveCrypto({
                                        symbol: c.id,
                                        price: livePriceData
                                          ? Number(livePriceData[c.id])
                                          : c.price / exchangeRate,
                                      });
                                      tradathon_setActivePrice({
                                        price: livePriceData
                                          ? Number(livePriceData[c.id])
                                          : c.price / exchangeRate,
                                      });
                                      tradathon_setSellType("buy");
                                      toggleTradathonModal();
                                    }}
                                  >
                                    <Badge name="Buy" />
                                  </div>
                                ) : (
                                  <div
                                    onClick={() => {
                                      toggleVtradingModal();
                                      setActiveCrypto({
                                        symbol: c.id,
                                        price: livePriceData
                                          ? Number(livePriceData[c.id])
                                          : c.price / exchangeRate,
                                      });
                                      setActivePrice({
                                        price: livePriceData
                                          ? Number(livePriceData[c.id])
                                          : c.price / exchangeRate,
                                        amount: 1,
                                      });
                                    }}
                                  >
                                    <Badge name="Buy" />
                                  </div>
                                )}
                              </div>
                            </td>
                          )}

                          {loading ? (
                            <td style={{ textAlign: "left" }}>
                              <div
                                className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                                style={{
                                  textAlign: "left",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <div
                                  className="skeleton text"
                                  style={{ width: "100px" }}
                                />
                                <div className="shimmer-wrapper">
                                  <div className="shimmer"></div>
                                </div>
                              </div>
                            </td>
                          ) : (
                            <Price
                              id={c.id}
                              item={Number(c.price) / exchangeRate}
                              property="price"
                              style2={{
                                justifyContent: "flex-end",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              style1={{ textAlign: "right" }}
                            />
                          )}
                          {loading ? (
                            <td style={{ textAlign: "left" }}>
                              <div
                                className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                                style={{
                                  textAlign: "left",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <div
                                  className="skeleton text"
                                  style={{ width: "60px" }}
                                />
                                <div className="shimmer-wrapper">
                                  <div className="shimmer"></div>
                                </div>
                              </div>
                            </td>
                          ) : c["1d"]?.price_change_pct ? (
                            <td style={{ textAlign: "right" }}>
                              <div
                                className="Home__MainTable-td"
                                style={{ justifyContent: "flex-end" }}
                              >
                                <div
                                  style={{
                                    color:
                                      (c["1d"]?.price_change_pct
                                        ? Number(c["1d"]?.price_change_pct)
                                        : "") > 0
                                        ? "rgba(69, 170, 67, 1)"
                                        : "rgba(233, 56, 72, 1)",
                                  }}
                                  className="Home__MainTable__pct"
                                >
                                  {Number(c["1d"].price_change_pct) > 0 ? (
                                    <AiFillCaretUp className="Home__MainTable__pcticon" />
                                  ) : (
                                    <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                                  )}
                                  &nbsp;
                                  <div>
                                    {Math.abs(
                                      Number(c["1d"].price_change_pct) * 100
                                    ).toFixed(2) + "%"}
                                  </div>
                                </div>
                              </div>
                            </td>
                          ) : (
                            <td style={{ textAlign: "right" }}>
                              <div
                                className="Home__MainTable-td"
                                style={{ justifyContent: "flex-end" }}
                              >
                                <div className="Home__MainTable__pct">NA</div>
                              </div>
                            </td>
                          )}

                          {loading ? (
                            <td style={{ textAlign: "left" }}>
                              <div
                                className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                                style={{
                                  textAlign: "left",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <div
                                  className="skeleton text"
                                  style={{ width: "60px" }}
                                />
                                <div className="shimmer-wrapper">
                                  <div className="shimmer"></div>
                                </div>
                              </div>
                            </td>
                          ) : c["7d"]?.price_change_pct ? (
                            <td style={{ textAlign: "right" }}>
                              <div
                                className="Home__MainTable-td"
                                style={{ justifyContent: "flex-end" }}
                              >
                                <div
                                  style={{
                                    color:
                                      Number(c["7d"]?.price_change_pct) > 0
                                        ? "rgba(69, 170, 67, 1)"
                                        : "rgba(233, 56, 72, 1)",
                                  }}
                                  className="Home__MainTable__pct"
                                >
                                  {Number(c["7d"]?.price_change_pct) > 0 ? (
                                    <AiFillCaretUp className="Home__MainTable__pcticon" />
                                  ) : (
                                    <AiOutlineCaretDown />
                                  )}
                                  &nbsp;
                                  <div>
                                    {Math.abs(
                                      Number(c["7d"]?.price_change_pct) * 100
                                    ).toFixed(2) + "%"}
                                  </div>
                                </div>
                              </div>
                            </td>
                          ) : (
                            <td style={{ textAlign: "right" }}>
                              <div
                                className="Home__MainTable-td"
                                style={{ justifyContent: "flex-end" }}
                              >
                                <div className="Home__MainTable__pct">NA</div>
                              </div>
                            </td>
                          )}

                          {loading ? (
                            <td style={{ textAlign: "left" }}>
                              <div
                                className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                                style={{
                                  alignItems: "flex-end",
                                  flexDirection: "column",
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                }}
                              >
                                <div
                                  className="skeleton text"
                                  style={{ width: "100px" }}
                                />
                                <div
                                  className="skeleton text"
                                  style={{ width: "60px" }}
                                />
                                <div className="shimmer-wrapper">
                                  <div className="shimmer"></div>
                                </div>
                              </div>
                            </td>
                          ) : c.market_cap ? (
                            <td style={{ textAlign: "right" }}>
                              <div
                                className="Home__MainTable-td"
                                style={{
                                  alignItems: "flex-end",
                                  flexDirection: "column",
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleClick(c.id)}
                              >
                                <div>
                                  <NumberFormat
                                    value={(
                                      Number(c.market_cap) / exchangeRate
                                    ).toFixed(0)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={`${currencySymbol} `}
                                  />
                                </div>
                                <div
                                  style={{ color: "#717171", fontSize: "12px" }}
                                >
                                  {currencySymbol}
                                  {formatNumber(
                                    Number(c.market_cap) / exchangeRate
                                  )}
                                </div>
                              </div>
                            </td>
                          ) : (
                            <td style={{ textAlign: "right" }}>
                              <div
                                className="Home__MainTable-td"
                                style={{ justifyContent: "flex-end" }}
                              >
                                <div className="Home__MainTable__pct">NA</div>
                              </div>
                            </td>
                          )}

                          {loading ? (
                            <td style={{ textAlign: "left" }}>
                              <div
                                className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                                style={{
                                  alignItems: "flex-end",
                                  flexDirection: "column",
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                }}
                              >
                                <div
                                  className="skeleton text"
                                  style={{ width: "100px" }}
                                />
                                <div
                                  className="skeleton text"
                                  style={{ width: "60px" }}
                                />
                                <div className="shimmer-wrapper">
                                  <div className="shimmer"></div>
                                </div>
                              </div>
                            </td>
                          ) : c["1d"]?.volume ? (
                            <Price
                              property="1dVolume"
                              id={c.id}
                              item1={Number(c["1d"].volume) / exchangeRate}
                              item={Number(c.price) / exchangeRate}
                              style2={{
                                alignItems: "flex-end",
                                flexDirection: "column",

                                // whiteSpace: "nowrap",
                              }}
                              style1={{ textAlign: "right" }}
                              style3={{ color: "#717171", fontSize: "12px" }}
                            />
                          ) : (
                            <td style={{ textAlign: "right" }}>
                              <div
                                className="Home__MainTable-td"
                                style={{ justifyContent: "flex-end" }}
                              >
                                <div className="Home__MainTable__pct">NA</div>
                              </div>
                            </td>
                          )}

                          <td
                            style={{ paddingLeft: "20px", cursor: "pointer" }}
                          >
                            {loading ||
                            !sparklineData ||
                            !sparklineData.length > 0 ? (
                              <div
                                className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                                style={{
                                  alignItems: "flex-end",
                                  flexDirection: "column",
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                }}
                              >
                                <div
                                  className="skeleton text"
                                  style={{ width: "130px", height: "40px" }}
                                />
                              </div>
                            ) : (
                              <Link to={`/cryptos/${c.id}`}>
                                <div
                                  className="Home__MainTable-td skeleton-wrapper light skeleton-article"
                                  style={{
                                    textAlign: "left",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <HomeChart
                                    symbol={c.id}
                                    time={index}
                                    data={
                                      sparklineData.filter(
                                        (i, index) => i.currency === c.id
                                      )[0]
                                        ? sparklineData.filter(
                                            (i, index) => i.currency === c.id
                                          )[0].prices
                                          ? sparklineData.filter(
                                              (i, index) => i.currency === c.id
                                            )[0].prices
                                          : []
                                        : []
                                    }
                                    color={
                                      Number(c["7d"]?.price_change_pct) > 0
                                        ? "rgba(69, 170, 67, 1)"
                                        : "rgba(233, 56, 72, 1)"
                                    }
                                  />
                                </div>
                              </Link>
                            )}
                            {/*</span>  <span className="Home__MainTable__row-name"> */}
                          </td>
                        </tr>
                      
                    ))
                  ) : (
                    <></>
                  )}
                </tbody>
              </table>
            )}
          </div>
          {/* {data && data.length > 0 && !loading ? <></> : <Loader />} */}
          {cryptoData && cryptoData.length > 0 && !loading && !filter ? (
            <Pagination pages={5} />
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

export default Home;
